import { Recipient } from '../../../../common/types/form'
import { downloadFileString } from './downloadCsvTemplate'
import {
    COLUMN_SEPARATOR,
    LINE_SEPARATOR,
    VALUES_SEPARATOR,
    GROUP_NAME_FIELD,
    RECIPIENTS_EMAIL_FIELD,
    LOOKUP_MACRO_FIELD,
    LOOKUP_KEY_FIELD
} from './types'

const exportRecipientsToCsv = (recipients: Recipient[], doDownload = true) => {
    let file = [GROUP_NAME_FIELD, RECIPIENTS_EMAIL_FIELD, LOOKUP_MACRO_FIELD, LOOKUP_KEY_FIELD].join(COLUMN_SEPARATOR)
    file += LINE_SEPARATOR

    if (!recipients || !Array.isArray(recipients) || recipients == null) {
        recipients = []
    }

    recipients.forEach(recipient => {
        const quotedRecipientName =
            recipient.name && (recipient.name.includes(COLUMN_SEPARATOR) || recipient.name.includes(LINE_SEPARATOR))
                ? `"${recipient.name}"`
                : recipient.name
        const recipientLines = []
        const defaultRecipientLine = {
            [GROUP_NAME_FIELD]: quotedRecipientName,
            [RECIPIENTS_EMAIL_FIELD]: [],
            [LOOKUP_MACRO_FIELD]: '',
            [LOOKUP_KEY_FIELD]: []
        }
        recipientLines[0] = JSON.parse(JSON.stringify(defaultRecipientLine))

        let emailsLineIdx = 0
        recipient.recipients?.forEach(email => {
            if (recipientLines[emailsLineIdx][RECIPIENTS_EMAIL_FIELD].length >= 3) {
                emailsLineIdx++
                if (recipientLines[emailsLineIdx] === undefined)
                    recipientLines[emailsLineIdx] = JSON.parse(JSON.stringify(defaultRecipientLine))
            }

            recipientLines[emailsLineIdx][RECIPIENTS_EMAIL_FIELD].push(email)
        })

        const lookups = recipient.lookups ?? {}
        let lookupLineIdx = 0
        Object.entries(lookups).forEach(([macro, keys]) => {
            if (recipientLines[lookupLineIdx][LOOKUP_MACRO_FIELD] !== '') {
                lookupLineIdx++
                if (recipientLines[lookupLineIdx] === undefined)
                    recipientLines[lookupLineIdx] = JSON.parse(JSON.stringify(defaultRecipientLine))
            }
            recipientLines[lookupLineIdx][LOOKUP_MACRO_FIELD] = macro

            keys.forEach(value => {
                if (recipientLines[lookupLineIdx][LOOKUP_KEY_FIELD].length >= 3) {
                    lookupLineIdx++
                    if (recipientLines[lookupLineIdx] === undefined) {
                        recipientLines[lookupLineIdx] = JSON.parse(JSON.stringify(defaultRecipientLine))
                    }
                    recipientLines[lookupLineIdx][LOOKUP_MACRO_FIELD] = macro
                }
                recipientLines[lookupLineIdx][LOOKUP_KEY_FIELD].push(value)
            })
        })
        recipientLines.forEach(line => {
            file += [
                line[GROUP_NAME_FIELD],
                `"${line[RECIPIENTS_EMAIL_FIELD].join(',')}"`,
                line[LOOKUP_MACRO_FIELD],
                `"${line[LOOKUP_KEY_FIELD].join(',')}"`
            ].join(COLUMN_SEPARATOR)
            file += LINE_SEPARATOR
        })
    })

    if (doDownload) downloadFileString(file, `export_recipients_groups.csv`)
    return file
}

export default exportRecipientsToCsv
